
import "./App.css";
import React, { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { YearProvider } from "./admin/components/YearContext";
import IndividualServicespage from "./landing/pages/IndividualServicespage";
import Businessservicespage from "./landing/pages/Businessservicespage";
import International from "./landing/pages/international";
import Payroll from "./landing/pages/payroll";
import Business from "./landing/pages/business";
import Businessreturns from "./landing/pages/businessreturns";
import Bookkeeping from "./landing/pages/Bookkeeping";
import Loader from "./landing/components/Loader";
import Boir from "./landing/pages/boir";

// Components
const Forgetpassword = React.lazy(() => import("./components/forgetpassword"));

// Landing Pages
const Home = React.lazy(() => import("./landing/pages/Home"));
const ContactUs = React.lazy(() => import("./landing/pages/Contactus"));
const PricesSection = React.lazy(() => import("./landing/pages/PricesSection"));
const AboutusHome = React.lazy(() => import("./landing/pages/AboutusHome"));
const Refundstatus = React.lazy(() => import("./landing/pages/Refundstatus"));
const Upperbox = React.lazy(() => import("./landing/pages/Upperbox"));
const Servicespage = React.lazy(() =>
  import("./landing/pages/IndividualServicespage")
);
const ReferAndEarn = React.lazy(() => import("./landing/pages/Referandearn"));
const Staterefundstatus = React.lazy(() =>
  import("./landing/pages/Staterefundstatus")
);
const Terms = React.lazy(() => import("./landing/pages/Terms"));
const Refundpolicy = React.lazy(() => import("./landing/pages/Refundpolicy"));
const Privacypolicy = React.lazy(() => import("./landing/pages/Privacypolicy"));
const Whatsapp = React.lazy(() => import("./landing/components/Whatsapp"));

const Federal = React.lazy(() => import("./landing/pages/federal"));
const Amendment = React.lazy(() => import("./landing/pages/amendment"));
const Itinpreparation = React.lazy(() =>
  import("./landing/pages/itinpreparation")
);
const Fbar = React.lazy(() => import("./landing/pages/fbar"));

const W4assistance = React.lazy(() => import("./landing/pages/w4assistance"));
const Taxextension = React.lazy(() => import("./landing/pages/taxextension"));
const Estimatetax = React.lazy(() => import("./landing/pages/estimatetax"));
const Taxplanning = React.lazy(() => import("./landing/pages/taxplanning"));
const Filingoptions = React.lazy(() => import("./landing/pages/filingoptions"));
const Representation = React.lazy(() =>
  import("./landing/pages/representation")
);

// Authentication
const Signup = React.lazy(() => import("./landing/components/signup"));
const Loginn = React.lazy(() => import("./landing/components/loginn"));

//Admin Pages
const Admindashboard = lazy(() => import("./admin/pages/Admindashboard"));
const Adminanalytics = lazy(() => import("./admin/pages/Adminanalytics"));
const Adminclients = lazy(() => import("./admin/pages/Adminclients"));
const Adminleads = lazy(() => import("./admin/pages/Adminleads"));
const Employeestatus = lazy(() => import("./admin/pages/Employeestatus"));
const Admindocuments = lazy(() => import("./admin/pages/Admindocuments"));
const Adminemployees = lazy(() => import("./admin/pages/Employeeinfo"));
const Admininvoice = lazy(() => import('./admin/pages/Admininvoice'));
const Adminpayments = lazy(() => import('./admin/pages/Adminpayments'));
const Searchclient = lazy(() => import("./admin/pages/SearchClient"));
const Adminprofile = lazy(() => import("./admin/pages/Adminprofile"));
const Adminsettings = lazy(() => import("./admin/pages/Adminsettings"));
const Clientviewdocs = lazy(() => import("./admin/pages/Clientviewdocs"));
const EditEmployee = lazy(() =>  import ('./admin/pages/EditEmployee'));
//employee pages
const Empdashboard = lazy(() => import("./employee/pages/Empdashboard"));
const Empprofile = lazy(() => import("./employee/pages/Empprofile"));
const Empshifts = lazy(() => import('./employee/pages/Empshifts'));
const Empleads = lazy(() => import("./employee/pages/Empleads"));
const Empinvoice = lazy(() => import('./employee/pages/Empinvoice'));
const Empclients = lazy(() => import("./employee/pages/Empclients"));
const Empdocuments = lazy(() => import("./employee/pages/Empdocuments"));
const Empsettings = lazy(() => import("./employee/pages/Empsettings"));
const Empclientviewdocs = lazy(() =>
  import("./employee/pages/Empclientviewdocs")
);
const Empsearchclient = lazy(() => import("./employee/pages/Empsearchclient"));
const Emppayments = lazy(() => import("./employee/pages/Emppayments"));

//client pages
const Clientdashboard = lazy(() => import("./client/pages/Clientdashboard"));
const Clienttaxorganizer = lazy(() => import("./client/pages/Taxorganizer"));
const Clientdocuments = lazy(() => import("./client/pages/Clientdocuments"));
const Clientreferandearn = lazy(() => import("./client/pages/Referandearn"));
const Clientinvoices = lazy(() => import('./client/pages/Clientinvoices'));
const Clientprofile = lazy(() => import("./client/pages/Clientprofile"));
const Clientsettings = lazy(() => import("./client/pages/Clientsettings"));
const Clienthelpcenter = lazy(() => import("./client/pages/Helpcenter"));

function App() {
  return (
    <YearProvider>
      <BrowserRouter>
        <ToastContainer position="top-right" />

        <Suspense
          fallback={
            <div className="loader-container">
              <div className="spinner"></div>
            </div>
          }
        >
          <Routes>
            {/* Public Pages */}
            <Route path="/" element={<Home />} />
            <Route path="/aboutus" element={<AboutusHome />} />
            <Route path="/servicespage" element={<Servicespage />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/price" element={<PricesSection />} />
            <Route path="/refundstatus" element={<Refundstatus />} />
            <Route path="/staterefundstatus" element={<Staterefundstatus />} />
            <Route path="/upperbox" element={<Upperbox />} />
            <Route path="/referandearn" element={<ReferAndEarn />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refundpolicy" element={<Refundpolicy />} />
            <Route path="/privacypolicy" element={<Privacypolicy />} />
            <Route path="/whatsapp" element={<Whatsapp />} />
            <Route
              path="/individualservicespage"
              element={<IndividualServicespage />}
            />
            <Route
              path="/businessservicespage"
              element={<Businessservicespage />}
            />
            <Route path="/federal" element={<Federal />} />
            <Route path="/amendment" element={<Amendment />} />
            <Route path="/itinpreparation" element={<Itinpreparation />} />
            <Route path="/fbar" element={<Fbar />} />
            <Route path="/w4assistance" element={<W4assistance />} />
            <Route path="/taxextension" element={<Taxextension />} />
            <Route path="/estimatetax" element={<Estimatetax />} />
            <Route path="/taxplanning" element={<Taxplanning />} />
            <Route path="/filingoptions" element={<Filingoptions />} />
            <Route path="/representation" element={<Representation />} />
            <Route path="/bookkeeping" element={<Bookkeeping />} />
            <Route path="/business" element={<Business />} />
            <Route path="/businessreturns" element={<Businessreturns />} />
            <Route path="/international" element={<International />} />
            <Route path="/payroll" element={<Payroll />} />
            <Route path="/boir" element={<Boir />} />
            {/* Authentication */}
            <Route path="/login" element={<Loginn />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgetpassword" element={<Forgetpassword />} />

            {/* Admin pages */}

            <Route path="/admin" element={<Admindashboard />} />
         
            <Route path="/adminanalytics" element={<Adminanalytics />} />
            <Route path="/clients" element={<Adminclients />} />
            <Route path="/leads" element={<Adminleads />} />
            <Route path="/employeestatus" element={<Employeestatus />} />
            <Route path="/documentstimeline" element={<Admindocuments />} />
            <Route path="/employeinformation" element={<Adminemployees />} />
            <Route path="/searchclient" element={<Searchclient />} />
            <Route path="/invoice" element={<Admininvoice />} />
            <Route path="/payments" element={<Adminpayments />} />
            <Route path="/adminprofile" element={<Adminprofile />} />
            <Route path="/adminsettings" element={<Adminsettings />} />
            <Route path="/viewclientdocs" element={<Clientviewdocs />} />
            <Route path="/edit-employee/:empId" element={<EditEmployee />} /> 
            
            {/* Employee pages */}
            <Route path="/employee" element={<Empdashboard />} />
            <Route path="/empProfile" element={<Empprofile />} />
            <Route path="/empshifts" element={<Empshifts />} />
            <Route path="/empLeads" element={<Empleads />} />
            <Route path="/empClients" element={<Empclients />} />
            <Route path="/empdocuments" element={<Empdocuments />} />
            <Route path="/empinvoices" element={<Empinvoice />} />
            <Route path="/empsettings" element={<Empsettings />} />
            <Route path="/empclientviewdocs" element={<Empclientviewdocs />} />
            <Route path="/empsearchclient" element={<Empsearchclient />} />
            <Route path="/emppayments" element={<Emppayments />} />

            {/* Client pages */}
            <Route path="/client" element={<Clientdashboard />} />
            <Route path="/taxorganizer" element={<Clienttaxorganizer />} />
            <Route path="/documents" element={<Clientdocuments />} />
            <Route
              path="/clientreferandearn"
              element={<Clientreferandearn />}
            />
                      <Route path="/clientinvoices" element={<Clientinvoices />} />
            <Route path="/clientprofile" element={<Clientprofile />} />
            <Route path="/settings" element={<Clientsettings />} />
            <Route path="/helpcenter" element={<Clienthelpcenter />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </YearProvider>
  );
}

export default App;
